import React, { ReactElement, PropsWithChildren } from "react";
import { Link } from "react-router-dom";
import useSubMenuItemsStyles, { SubMenuItemsClasses } from "./styles";

export type SubMenuItemsData = {
  icon: ReactElement;
  label: string;
  link: string;
};

export type SubMenuItemsProps = {
  menuItems?: Array<SubMenuItemsData>;
};

function SubMenuItems({
  menuItems = [{ icon: <></>, label: "", link: "" }],
}: PropsWithChildren<SubMenuItemsProps>): ReactElement {
  const useStyles: SubMenuItemsClasses = useSubMenuItemsStyles();

  const subMenuItemBuilder = menuItems.map((data, i) => {
    return (
      <Link to={data.link} className={useStyles.serviceMenuItemLink} key={i}>
        <div className={useStyles.serviceMenuItemContainer}>
          {data.icon}
          <div className={useStyles.serviceMenuItemText}>{data.label}</div>
        </div>
      </Link>
    );
  });

  return (
    <>
      <div className={useStyles.serviceMenuItemBox}>{subMenuItemBuilder}</div>
    </>
  );
}
export default SubMenuItems;
